export enum EClustersType {
  Detailed = 'detailed',
  Peas = 'peas',
  OpenablePeas = 'openablePeas',
}
